import React, { useEffect, useState } from 'react';
import { questionarioCommercial } from '../questions';
import { FormInputRadio } from '../../../../common/formInputsV2/FormInputRadio';
import { flagResponse } from '../../../../common/constants';
import { Accordion } from '../../../../common/components/Accordion';

function InfrastructureImpianti({
  register,
  errorMessages,
  errors,
  questions,
}) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (
      Object.keys(errors).some((key) => key.includes('infrastructure_and_machines'))
    ) {
      setHasError(true);
    }
  }, [errors]);

  return (
    <Accordion
      title={questionarioCommercial[2].title}
      defaultOpen={false}
      hasError={hasError}
      setHasError={setHasError}
    >
      <ul className="list-unstyled">
        {questions.find((el) => el.title === 'Infrastrutture e Impianti')
          !== undefined
          && questions
            .find((el) => el.title === 'Infrastrutture e Impianti')
            .questions?.map((question, index) => (
              <li className="mb-2" key={index}>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <p className="mb-0 text-center">{question.question}</p>
                  <FormInputRadio
                    registration={register(question.input_name)}
                    options={flagResponse}
                    error={errorMessages(question.input_name)}
                  />
                </div>
              </li>
            ))}
        {/* {questionarioCommercial[2].questions.map((question, index) => (
          <li className='mb-2' key={index}>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <p className='mb-0 text-center'>{question.question}</p>
              <FormInputRadio
                registration={register(`${question.input_name}`)}
                options={flagResponse}
                error={errorMessages(question.input_name)}
              />
            </div>
          </li>
        ))} */}
      </ul>
    </Accordion>
  );
}

export default InfrastructureImpianti;
